import { Component, Input, OnInit } from '@angular/core';
import { StateFacade } from '../../data-access/+state/facades/state.facade';

@Component({
  selector: 'idp-partners',
  templateUrl: './partners.component.html',
  styleUrls: ['./partners.component.scss']
})
export class PartnersComponent implements OnInit {
  @Input() showLinked = false;

  constructor(public partners: StateFacade) {}

  ngOnInit() {
    this.partners.init(this.showLinked);
  }

  redirect(link: string) {
    window.open(link, '_blank');
  }
}
